var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderH3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8268 15.85C17.1272 15.85 18.0084 15.1746 18.0084 14.1575C18.0084 13.385 17.4688 12.8959 16.6342 12.8182V12.795C17.2942 12.6591 17.8027 12.1933 17.8027 11.4829C17.8027 10.5862 17.003 10 15.819 10C14.8292 10 14.1925 10.4581 13.9441 11.0054C13.8859 11.1374 13.8587 11.25 13.8587 11.382C13.8587 11.6653 14.0256 11.8555 14.3517 11.8555C14.6157 11.8555 14.7515 11.7585 14.8796 11.4945C15.0621 11.0986 15.3493 10.9006 15.8229 10.9006C16.3897 10.9006 16.6925 11.1995 16.6925 11.6498C16.6925 12.1079 16.312 12.4262 15.7259 12.4262H15.4968C15.2135 12.4262 15.0504 12.597 15.0504 12.8415C15.0504 13.0939 15.2135 13.2608 15.4968 13.2608H15.7414C16.4207 13.2608 16.8206 13.5636 16.8167 14.107C16.8167 14.5729 16.4207 14.9067 15.8462 14.9067C15.2639 14.9067 14.9611 14.6738 14.7632 14.2817C14.6467 14.0682 14.4992 13.975 14.2663 13.975C13.9441 13.975 13.75 14.1653 13.75 14.468C13.75 14.5845 13.7772 14.7087 13.8393 14.8368C14.1033 15.3881 14.7593 15.85 15.8268 15.85Z",
    fill: "#1D2B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5V15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 5V15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 9.99967H10.8334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderH3);
export default ForwardRef;